import useConfig from 'hooks/useConfig';
import React from 'react';

export default function TechSupportWatermark() {
    const { mode } = useConfig();
    
    const isNantong = process.env.REACT_APP_PLATFORM_SERVER.toUpperCase() === 'NANTONG';
    if (!isNantong) return;
    // console.log(isNantong)
    // const logoImg = isChina
    //     ? isNantong ? `${process.env.PUBLIC_URL}/favicon-nt.png` : `${process.env.PUBLIC_URL}/favicon-china.png`
    //     : `${process.env.PUBLIC_URL}/favicon.png`;
    const logoImg = mode === "light" ? `${process.env.PUBLIC_URL}/yihai_b.svg` : `${process.env.PUBLIC_URL}/yihai.svg`
    
  return (
    <div className='watermarkContainer'>
        <img src={logoImg} alt='' className='logo' />
    </div>
  );
}